const ProducsData = [
  {
    installments: "em até 3x no cartão",
    type: "Thermo abdômen",
    productBrand: "Bodyaction",
    description: "60 caps",
    priceWithoutDiscount: "100.00",
    quantity: "0",
    imageSrc: require("../../assets/ImgProducts/Thermogenic/thermo_abdomen_60caps.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Pré treino Psicho Killer ",
    productBrand: "Demons-Lab",
    description: "294g",
    priceWithoutDiscount: "100.00",
    quantity: "1",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_psycho_killer_294g.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Hipercalórico",
    productBrand: "Diabo-Verde",
    description: "2,5Kg",
    priceWithoutDiscount: "90.00",
    quantity: "5",
    imageSrc: require("../../assets/ImgProducts/Hypercaloric/diabo_verde_massivemass_hypercaloric_2_5kg-refil.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Pré treino Crack",
    productBrand: "Demons-Lab",
    description: "300g",
    priceWithoutDiscount: "100.00",
    quantity: "10",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_crack_300g.png"),
  },
];

export default ProducsData;
